var _path, _path2, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMeetings = function SvgMeetings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 9.536c0 4.162-4.017 7.536-8.973 7.536-.99 0-1.942-.135-2.833-.384-.866-.242-5.413 2.706-6.14 2.268-.472-.471 2.306-3.768.945-6.051a6.54 6.54 0 0 1-.944-3.37C1.055 5.375 5.072 2 10.027 2 14.983 2 19 5.374 19 9.536"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 7.5c3.179.5 4.79 5.85 3.179 8.56-1.1 1.85 1.145 4.522.763 4.904-.587.355-4.262-2.033-4.961-1.838a8.5 8.5 0 0 1-2.29.311C15.109 19.437 12 20 10 17.5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 10,
    r: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 10,
    r: 0.5
  })));
};
export default SvgMeetings;